window.optimizely = window.optimizely || [];

/* istanbul ignore next */
export function push(payload) {
  window.optimizely.push(payload);
  /* istanbul ignore next */
  if (__DEBUG__) console.debug('optimizely.push', payload); // eslint-disable-line no-console
}

export const fireEvent = (className, event) => {
  const validEvents = ['selected', 'displayed', 'clicked'];
  push({
    type: 'event',
    eventName: `${event} ${className}`,
  });
  /* istanbul ignore next */
  if (__DEBUG__ && !validEvents.includes(event)) console.error(`optimizely.fireEvent: invalid event type ${event}`); // eslint-disable-line no-console
};

export const firePageViewEvent = (pageName) => {
  push({
    type: 'event',
    eventName: pageName,
  });
};

export const activate = () => {
  push({
    type: 'activate',
  });
  /* istanbul ignore next */
  if (__DEBUG__) console.debug('optimizely.activate'); // eslint-disable-line no-console
};

export function getDeviceType() {
  const userAgent = window.navigator.userAgent;
  let siteType;

  if (/iPad/.test(userAgent)) {
    siteType = 'Tablet';
  } else if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(userAgent)) {
    siteType = 'Phone';
  } else {
    siteType = 'Desktop';
  }

  return siteType;
}

export function fireOptimizelyRevenueEventOnce(data) {
  if (data.isEnablePurchaseTracking) {
    push({
      type: 'event',
      eventName: data.bookTypeEventName,
    });
    if (data.isExpectedRevenueWithinRange) {
      push({
        type: 'user',
        attributes: {
          product_type: data.bookTypeId,
        },
      });
      push({
        type: 'event',
        eventName: 'booking_revenue',
        tags: {
          revenue: data.expectedRevenueDcstorm,
        },
      });
    }
  }
}

export function fireOptimizelyAncillaryEvent(data) {
  if (data.hasTransfer) {
    push({
      type: 'event',
      eventName: 'confirmationPage-transfer--selected',
    });
  }
  if (data.hasBaggage && !!data.hasBaggage.size) {
    push({
      type: 'event',
      eventName: 'confirmationPage-holdLuggage--selected',
    });
  }
  if (data.hasInsurance) {
    push({
      type: 'event',
      eventName: 'confirmationPage-insurance--selected',
    });
  }
  if (data.hasFlightMeals) {
    push({
      type: 'event',
      eventName: 'confirmationPage-flightMeals--selected',
    });
  }
  if (data.hasBaggage && data.amountOfBags > 0) {
    push({
      type: 'event',
      eventName: `confirmationPage-${data.amountOfBags}-baggage--selected`,
    });
  }
}

export function fireOptimizelyBoardTypeEvent(data) {
  if (data.boardBasis) {
    push({
      type: 'event',
      eventName: `confirmationPage-${data.boardBasis}-BoardBasis--selected`,
    });
  }
}



/** WEBPACK FOOTER **
 ** ./src/utils/optimizely.js
 **/